import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { TrackProductCrossSellClick } from '@app/+product/store';

/**
 * When the user clicks on a product in the cross-sell module on the product page.
 */
const events = getEvents((action: TrackProductCrossSellClick) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'productCrossSellClick',
      itemPosition: action.payload.position,
      product_id_destination: action.payload.productId,
      productModuleTitle: action.payload.title
    }
  }
]);

export default events;
